export default "__VITE_ASSET__Du0dw1_1__"